import styled from '@emotion/styled';
import ButtonBase from '@material-ui/core/ButtonBase';
import ExpandMore from '@material-ui/icons/ExpandMore';

import COLORS from '$variables/colors';
import { typography } from '$variables/theme';

export const Button = styled(ButtonBase)`
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px;
  background: ${COLORS.grey2};
  border-radius: 4px;
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};
  line-height: 20px;
  display: flex;

  &:hover {
    background: ${COLORS.grey4};
  }
`;

export const ButtonLabel = styled.span`
  color: ${({ disabled }) => (disabled ? COLORS.grey3 : COLORS.black)};
  flex-grow: 1;
  text-align: left;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${typography.fontFamily};
`;

export const Placeholder = styled.span`
  color: ${COLORS.grey3};
`;

export const ExpandIcon = styled(ExpandMore)`
  color: ${({ disabled }) => (disabled ? COLORS.grey3 : COLORS.black)};
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);

  ${({ open }) =>
    open &&
    `
    transform: rotate(180deg);
  `};
`;

export const LeftDecorationContainer = styled.div`
  margin-right: 8px;
  height: 24px;
  width: 24px;
`;

export const SubText = styled.div`
  text-transform: uppercase;
  font-size: 10px;
  font-weight: ${typography.fontWeightRegular};
  color: ${COLORS.shadow5};
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
